import { DevicesActionTypes } from '../types';
import { TOGGLE_SELECT_DEVICE } from '../constants/actionTypes';

export const toggleSelectDevice = (deviceId: string): DevicesActionTypes => ({
  type: TOGGLE_SELECT_DEVICE,
  payload: deviceId,
});
